import { timelineCase, scaleLevels } from "@/mocks/melonData";
import { SectionHeading, SectionShell, verdictStyle } from "./brand";

const stepIcon: Record<string, string> = {
  collected: "ri-folder-2-line",
  trace: "ri-search-eye-line",
  verify: "ri-git-merge-line",
  source: "ri-contacts-book-line",
  verdict: "ri-medal-line",
};

export default function TruthTimeline() {
  const st = verdictStyle(timelineCase.verdict);
  const caseMeta = scaleLevels.find((s) => s.name === timelineCase.verdict)!;

  return (
    <SectionShell id="timeline">
      <SectionHeading
        eyebrow="取证时间线 · 单案例全流程"
        title="一条「实锤」是如何炼成的"
        desc="不甩一句「有图有真相」就完事。我们把取证过程摊开给你看：何时收料、如何溯源、为何敢定级，以及我们承认了什么不足。"
      />

      <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_360px]">
        {/* 左侧时间线 */}
        <ol className="relative space-y-6 before:absolute before:left-[13px] before:top-2 before:bottom-2 before:w-px before:bg-background-300 md:before:left-[15px]">
          {timelineCase.items.map((item) => (
            <li key={item.time} className="relative flex gap-4 md:gap-6 pl-0">
              <span className="mt-1.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50 md:h-8 md:w-8">
                <i className={stepIcon[item.status] ?? "ri-check-line"} />
              </span>
              <div className="flex-1 rounded-2xl border border-background-200 bg-background-50 p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-1 rounded-md bg-background-100 px-2.5 py-1 text-xs font-semibold text-foreground-800 whitespace-nowrap">
                    {item.time}
                  </span>
                  <span
                    className={`inline-flex items-center rounded-md border px-2.5 py-1 text-xs whitespace-nowrap ${st.soft}`}
                  >
                    {item.tag}
                  </span>
                </div>
                <h3 className="mt-3 text-base font-semibold text-foreground-950 leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  {item.desc}
                </p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {item.evidence.map((ev) => (
                    <span
                      key={ev}
                      className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 text-xs text-accent-900 whitespace-nowrap"
                    >
                      <i className="ri-check-double-line" />
                      {ev}
                    </span>
                  ))}
                </div>
              </div>
            </li>
          ))}
        </ol>

        {/* 右侧结论卡 */}
        <aside className="lg:sticky lg:top-24 h-fit space-y-4">
          <div className="rounded-2xl border border-background-200 bg-background-100 p-6">
            <p className="text-xs text-secondary-800">本案结论</p>
            <h3 className="mt-2 text-lg font-semibold text-foreground-950 leading-snug">
              {timelineCase.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              {timelineCase.intro}
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span
                className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-sm font-semibold whitespace-nowrap ${st.pill}`}
              >
                {timelineCase.verdict} · 可信 {timelineCase.score}
              </span>
            </div>
            <div className="mt-4 h-2 overflow-hidden rounded-full bg-background-200">
              <div
                className={`h-full rounded-full ${st.bar}`}
                style={{ width: `${timelineCase.score}%` }}
              />
            </div>
            <p className="mt-3 text-xs text-foreground-600">{caseMeta.desc}</p>
          </div>

          <div className="rounded-2xl border border-background-200 bg-background-100 p-6">
            <p className="text-sm font-semibold text-foreground-950">
              评级怎么来的？
            </p>
            <ul className="mt-4 space-y-3">
              {scaleLevels.map((lv) => (
                <li key={lv.name} className="flex items-start gap-3">
                  <span
                    className={`mt-1 inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold whitespace-nowrap ${
                      lv.name === "实锤"
                        ? "bg-accent-500 text-background-50"
                        : lv.name === "辟谣"
                          ? "bg-primary-500 text-background-50"
                          : "bg-secondary-500 text-background-50"
                    }`}
                  >
                    {lv.name}
                  </span>
                  <div>
                    <p className="text-xs font-medium text-foreground-800">
                      {lv.range}
                    </p>
                    <p className="mt-0.5 text-xs text-foreground-600 leading-relaxed">
                      {lv.desc}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <a
            href="#pending"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-6 py-3 text-sm text-background-50 hover:bg-foreground-800 transition-colors"
          >
            去围观求证进行中
            <i className="ri-arrow-right-line" />
          </a>
        </aside>
      </div>
    </SectionShell>
  );
}